import type { RootState } from '..';
import type { AddToSymbolCacheAction, RemoveFromSymbolCacheAction, SetSymbolCacheAction } from '../actions/ui';
import { select } from '../effects';
import { ChronoUnit, Instant } from '@js-joda/core';
import { all, takeLatest } from 'redux-saga/effects';
import { SYMBOL_CACHE_KEY } from 'src/lib/constants/storage-keys';
import { localforage } from 'src/lib/serialization/localForage';
import { container } from 'src/StaticContainer';

const log = container.get('Logger').getSubLogger({ name: 'ui-sagas' });

export function* onSymbolCacheSet(
    _action: SetSymbolCacheAction | AddToSymbolCacheAction | RemoveFromSymbolCacheAction,
) {
    const symbolCache: RootState['ui']['symbolCache'] = yield select((x) => x.ui.symbolCache);
    const expiresAt = Instant.now().minus(7, ChronoUnit.DAYS);
    try {
        yield localforage.setItem(
            SYMBOL_CACHE_KEY,
            symbolCache.filter((x) => x.lastUse.isAfter(expiresAt)),
        );
    } catch (error) {
        if (error instanceof Error) {
            log.error({ message: error.message, error });
        } else {
            log.fatal({ message: 'Unknown exception', details: error });
        }
    }
}

export function* uiSagas() {
    yield all([
        takeLatest('symbol-cache::set', onSymbolCacheSet),
        takeLatest('symbol-cache::add', onSymbolCacheSet),
        takeLatest('symbol-cache::remove', onSymbolCacheSet),
    ]);
}
